"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputDelayException = void 0;
class OutputDelayException extends Error {
    // #region Constructors (1)
    /**
     * Exception that is thrown when there is an output with a delay property.
     *
     * @param _delay the milliseconds to wait
     */
    constructor(_delay) {
        super();
        this._delay = _delay;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (1)
    get delay() {
        return this._delay;
    }
}
exports.OutputDelayException = OutputDelayException;
//# sourceMappingURL=OutputDelayException.js.map